import Enum from "./Enum";

export default Enum.create( {
	CALL_ENDED: "call_ended",
	DONE: "done",
	FATAL: "fatal",
	IN_CALL_NOT_RECORDING: "in_call_not_recording",
	IN_CALL_RECORDING: "in_call_recording",
	IN_WAITING_ROOM: "in_waiting_room",
	JOINING_CALL: "joining_call",
	SCHEDULED: "teaming_scheduled",
} );
